import React from 'react';
import 'assets/scss/timeline.scss';
export const TimelineContainer = props => {
    const { children } = props;
    return (React.createElement("div", { className: 'timeline', id: 'timeline' }, children));
};
